module.exports = __webpack_public_path__ + "img/step1.825900b4.svg";